(() => {
  'use strict';
  if (customElements.get('bh-owner-dashboard')) return;
  const states = new WeakMap();
  function mount(root) {
    if (states.has(root)) return;
    const events = new AbortController();
    const requests = new Set();
    const timers = new Set();
    const urls = new Set();
    const $ = (name) => root.querySelector('[data-owner-id="' + name + '"]');
    let session = null, dashboard = null, active = true, epoch = 0, expiry;
    let T;
    try { T = JSON.parse(root.querySelector('[data-bho-texts]').textContent); } catch { return; }
    const base = root.dataset.apiBase;
    const format = (text, values) => Object.entries(values).reduce((s,[k,v])=>s.replace('{' + k + '}',String(v)),text);
    const on = (target, event, fn) => target.addEventListener(event,fn,{signal:events.signal});
    function privateClear() {
      dashboard = null;
      ['visits','votes','conversion','contacts','conversion-detail','owner-title','generated','dashboard-message','profile-message'].forEach(id=>{if($(id))$(id).textContent='';});
      ['budget-chart','reason-chart','travel-chart','source-chart','trend-chart','abuse-chart','metric-limits','owner-deliverables'].forEach(id=>$(id)?.replaceChildren());
      $('profile-form').reset();
      $('profile-form').querySelector('[data-bho-fields]').disabled=true;
      for (const name of ['title','story','care']) $('profile-form').elements[name].value='';
      if(expiry)clearTimeout(expiry);
    }
    function loginView(message='') {
      epoch++;
      privateClear();
      session = null;
      $('login-form').querySelector('[data-bho-fields]').disabled=false;
      $('login').hidden=false;
      $('dashboard').hidden=true;
      $('login-message').textContent=message;
    }
    async function request(path,data,raw=false) {
      const currentEpoch=epoch;
      const abort=new AbortController();requests.add(abort);
      const headers={};
      if(session?.sessionToken)headers['X-BH-Session']=session.sessionToken;
      if(data)headers['Content-Type']='application/json';
      try {
        const response=await fetch(base+'/api'+path,{method:data?'POST':'GET',credentials:'omit',cache:'no-store',headers,signal:abort.signal,body:data?JSON.stringify({...data,csrf:session?.csrf}):undefined});
        if(!active||currentEpoch!==epoch)throw new DOMException('Cancelled','AbortError');
        if(raw&&response.ok)return response;
        let value;
        try{value=await response.json();}catch{throw new Error(T.invalid_response);}
        if(!active||currentEpoch!==epoch)throw new DOMException('Cancelled','AbortError');
        if(!response.ok){
          if(response.status===401){loginView(T.session_expired);throw new Error(T.session_expired);}
          throw new Error(value.message||value.error||T.error);
        }
        if(value.csrf)session={...session,csrf:value.csrf};
        if(value.sessionToken)session={...session,sessionToken:value.sessionToken};
        return value;
      } finally {requests.delete(abort);}
    }
    async function ensureSession() {
      if(session?.sessionToken&&session.csrf)return;
      const value=await request('/session');
      if(!value.sessionToken||!value.csrf)throw new Error(T.no_token);
      session={...value};
      $('login-form').querySelector('[data-bho-fields]').disabled=false;
    }
    function showError(error) {
      if(error.name==='AbortError'||!active)return;
      if($('dashboard').hidden)$('login-message').textContent=error.message||T.connection;
      else $('dashboard-message').textContent=error.message||T.connection;
    }
    function chart(id,data,labels,total) {
      const target=$(id);target.replaceChildren();
      const items=Object.entries(data||{});
      if(!items.some(([,v])=>v>0)){
        const p=document.createElement('p');p.className='empty';p.textContent=T.empty;target.append(p);return;
      }
      const denominator=total||items.reduce((n,[,v])=>n+v,0);
      for(const [key,value]of items){
        const row=document.createElement('div');row.className='bar-row';
        const label=document.createElement('div');label.className='bar-label';
        const name=document.createElement('span');name.textContent=labels?.[key]||key;
        const count=document.createElement('span');count.textContent=value+' · '+(denominator?Math.round(value/denominator*100):0)+'%';label.append(name,count);
        const bar=document.createElement('div');bar.className='bar';const fill=document.createElement('span');fill.style.width=(denominator?Math.min(100,value/denominator*100):0)+'%';bar.append(fill);row.append(label,bar);target.append(row);
      }
    }
    function downloadBlob(blob,filename) {
      const url=URL.createObjectURL(blob);urls.add(url);
      const a=document.createElement('a');a.href=url;a.download=filename;root.append(a);a.click();a.remove();
      const timer=setTimeout(()=>{URL.revokeObjectURL(url);urls.delete(url);timers.delete(timer);},1000);timers.add(timer);
    }
    async function download(kind) {
      const identity=epoch;
      const response=await request(kind==='csv'?'/owner/export.csv':'/owner/report.json',undefined,true);
      const blob=await response.blob();
      if(!active||identity!==epoch)throw new DOMException('Cancelled','AbortError');
      downloadBlob(blob,'bikinihouses-interes'+(session?.demo?'-demo':'')+'.'+(kind==='csv'?'csv':'json'));
      $('dashboard-message').textContent=T.downloaded;
    }
    function deliverables() {
      const target=$('owner-deliverables');target.replaceChildren();
      const items=[['01',T.profile,T.local_ready,root.dataset.profileUrl],['02',T.concept,T.concept_label,root.dataset.conceptUrl],['03',T.video,T.unpublished,root.dataset.videoUrl],['04',T.report,T.live_report,'report'],['05',T.sample,T.unpublished,root.dataset.sampleUrl]];
      for(const [number,title,status,url]of items){
        const item=document.createElement('div');item.className='deliverable';const n=document.createElement('span');n.className='number';n.textContent=number;const body=document.createElement('div');const strong=document.createElement('strong');strong.textContent=title;
        const control=document.createElement(url==='report'?'button':'a');control.textContent=T.view;
        if(url==='report'){control.type='button';control.className='text-button';control.dataset.download='json';}
        else control.href=url;
        body.append(strong,document.createElement('br'),control);const tag=document.createElement('span');tag.className='label';tag.textContent=status;item.append(n,body,tag);target.append(item);
      }
    }
    async function load() {
      const identity=epoch;
      const value=await request('/owner/dashboard');
      const profile=await request('/profile');
      if(!active||identity!==epoch)return;
      dashboard=value;
      $('login').hidden=true;$('dashboard').hidden=false;
      $('profile-form').querySelector('[data-bho-fields]').disabled=false;
      const customerMode=session?.verificationProvider==='shopify_customer';
      $('results-note').textContent=value.demo?T.records_demo:T.records_live;
      $('vote-rule').textContent=customerMode?T.vote_account:T.vote_email;
      $('notification-rule').textContent=customerMode?T.notification_disabled:T.notification_consent;
      $('visits').textContent=value.visits;$('votes').textContent=value.confirmedVotes;$('contacts').textContent=customerMode?'—':value.notificationOptIns;
      $('conversion').textContent=value.conversionRate===null?'—':Number(value.conversionRate).toLocaleString('es-MX',{maximumFractionDigits:1})+'%';
      $('conversion-detail').textContent=format(T.vote_sessions,{votes:value.conversionNumerator,sessions:value.conversionDenominator});
      $('campaign-state').textContent=value.campaign.paused?T.paused:T.review;
      $('campaign-toggle').textContent=value.campaign.paused?T.resume:T.pause;
      chart('budget-chart',value.budgets,{under_1000:T.budget_under,'1000_1500':T.budget_1000,'1500_2000':T.budget_1500,over_2000:T.budget_over,unknown:T.unknown},value.confirmedVotes);
      chart('reason-chart',value.reasons,{quiet:T.quiet,landscape:T.landscape,design:T.design,host:T.host},value.confirmedVotes);
      chart('travel-chart',value.travel,{couple:T.couple,family:T.family,solo:T.solo,friends:T.friends},value.confirmedVotes);
      chart('source-chart',value.sources,{direct:T.direct,instagram:T.instagram,facebook:T.facebook,youtube:T.youtube,tiktok:T.tiktok,shopify:T.shopify,shared:T.shared,other:T.other});
      chart('trend-chart',Object.fromEntries(value.trend.map(x=>[x.date,x.votes])));
      chart('abuse-chart',value.abuse,{rate_limited:T.rate_limited,honeypot:T.honeypot,too_fast:T.too_fast,invalid_code:T.invalid_code,duplicate:T.duplicate});
      const limits=$('metric-limits');limits.replaceChildren();
      for(const text of [T.session_note,...value.limits]){const li=document.createElement('li');li.textContent=text;limits.append(li);}
      $('generated').textContent=format(T.updated,{date:new Date(value.generatedAt*1000).toLocaleString('es-MX',{timeZone:'America/Mexico_City'})});
      $('owner-title').textContent=profile.title;
      for(const name of ['title','story','care','stage'])$('profile-form').elements[name].value=profile[name];
      deliverables();
    }
    async function action(button,fn) {
      button.disabled=true;
      try{await fn();}catch(error){showError(error);}finally{if(active)button.disabled=false;}
    }
    on($('login-form'),'submit',e=>{
      e.preventDefault();
      action(e.submitter,async()=>{
        $('login-message').textContent='';await ensureSession();
        const value=await request('/owner/login',{password:e.target.elements.password.value});
        e.target.reset();
        if(!session?.sessionToken)throw new Error(T.no_token);
        if(expiry)clearTimeout(expiry);
        expiry=setTimeout(()=>loginView(T.session_expired),Math.min(value.expiresIn||3600,3600)*1000);
        await load();
      });
    });
    on(root,'click',e=>{
      const target=e.target.closest('button');if(!target||!root.contains(target))return;
      if(target.dataset.action==='logout')action(target,async()=>{try{await request('/owner/logout',{});}finally{loginView(T.not_authenticated);}});
      if(target.dataset.download)action(target,()=>download(target.dataset.download));
      if(target.dataset.tab){root.querySelectorAll('[data-tab]').forEach(b=>{b.classList.toggle('active',b===target);b.setAttribute('aria-pressed',String(b===target));$(b.dataset.tab+'-panel').hidden=b!==target;});}
    });
    on($('profile-form'),'submit',e=>{e.preventDefault();action(e.submitter,async()=>{await request('/owner/profile',Object.fromEntries(new FormData(e.target)));await load();$('profile-message').textContent=T.saved;});});
    on($('campaign-toggle'),'click',e=>action(e.target,async()=>{await request('/owner/campaign',{action:dashboard.campaign.paused?'resume':'pause'});await load();}));
    on($('refresh'),'click',e=>action(e.target,load));
    on($('print-report'),'click',()=>window.print());
    const state={destroy(){active=false;epoch++;events.abort();for(const abort of requests)abort.abort();requests.clear();for(const timer of timers)clearTimeout(timer);for(const url of urls)URL.revokeObjectURL(url);privateClear();session=null;states.delete(root);}};
    states.set(root,state);
    if(!/^\/apps\/[a-zA-Z0-9][a-zA-Z0-9_-]*$/.test(base)){loginView(T.invalid_base);return;}
    ensureSession().catch(showError);
  }
  class OwnerDashboard extends HTMLElement {
    connectedCallback(){mount(this);}
    disconnectedCallback(){states.get(this)?.destroy();}
  }
  customElements.define('bh-owner-dashboard',OwnerDashboard);
  document.querySelectorAll('[data-bh-owner]').forEach(mount);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bh-owner]').forEach(mount));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-bh-owner]').forEach(root=>states.get(root)?.destroy()));
})();
